{
    "Air conditioning": {
        "en": "",
      "de": "Klimaanlage",
      "fr": "Climatisation",
      "it": "Aria condizionata"
    },
    "Charging station electric cars": {
        "en": "",
      "de": "Ladestation für Elektroautos",
      "fr": "Station de recharge pour voitures électriques",
      "it": "Stazione di ricarica per auto elettriche"
    },
    "Children's playground": {
        "en": "",
      "de": "Kinderspielplatz",
      "fr": "Aire de jeux pour enfants",
      "it": "Parco giochi per bambini"
    },
    "Elevators": {
        "en": "",
      "de": "Aufzüge",
      "fr": "Ascenseurs",
      "it": "Ascensori"
    },
    "Exercise gym": {
        "en": "",
      "de": "Fitnessstudio",
      "fr": "Salle de sport",
      "it": "Palestra"
    },
    "Free high speed internet connection": {
        "en": "",
      "de": "Kostenloses Hochgeschwindigkeits-Internet",
      "fr": "Internet haut débit gratuit",
      "it": "Internet ad alta velocità gratuito"
    },
    "Indoor parking": {
        "en": "",
      "de": "Innenparkplatz",
      "fr": "Parking intérieur",
      "it": "Parcheggio interno"
    },
    "Non-smoking rooms": {
        "en": "",
      "de": "Nichtraucherzimmer",
      "fr": "Chambres non-fumeurs",
      "it": "Camere non fumatori"
    },
    "Outdoor parking": {
        "en": "",
      "de": "Aussenparkplatz",
      "fr": "Parking extérieur",
      "it": "Parcheggio esterno"
    },
    "Pets allowed": {
        "en": "",
      "de": "Haustiere erlaubt",
      "fr": "Animaux de compagnie admis",
      "it": "Animali domestici ammessi"
    },
    "Restaurant": {
        "en": "",
      "de": "Restaurant",
      "fr": "Restaurant",
      "it": "Ristorante"
    },
    "Sauna": {
        "en": "",
      "de": "Sauna",
      "fr": "Sauna",
      "it": "Sauna"
    },
    "Steam Bathing": {
        "en": "",
      "de": "Dampfbad",
      "fr": "Bain de vapeur",
      "it": "Bagno turco"
    },
    "Pool": {
        "en": "",
      "de": "Schwimmbad",
      "fr": "Piscine",
      "it": "Piscina"
    }
  }